// @flow strict
import { type ComponentType } from "react";
import styled from "styled-components";

type Props = {
  numFulfilled: number,
  nuRequired: number,
};

const Header2: ComponentType<Props> = styled.h4`
  display: inline-block !important;
  margin-bottom: 0 !important;
  font-weight: 900 !important;
  color: ${({ numFulfilled, numRequired, theme }) => {
    if (numFulfilled === numRequired) return theme.colors.success("1");
    if (numFulfilled === 0) return theme.colors.danger("1");
    return theme.colors.primary_black("1");
  }} !important;
`;

export default Header2;
